import { server } from './server'
import { CommonConfig } from "src/index";
import {
    viewerSearchApiUrl, annotationApiUrl, bookmarkApiUrl,
    baseUrlApi, coursesApiUrl, dashboardApiUrl,
    globalSearchApiUrl, guidesApiUrl, userApiUrl,
    userProfileApiUrl, viewerApiUrl, exerciseApiUrl,
    baseUserUrlApi, baseContentUrlApi, baseAnnotationUrlApi,
    baseExerciseUrlApi, selfAssessmentApiUrl,
    publicApiUrl, teachersApiUrl, eventsApiUrl, baseEventsUrlApi,
    faqsApiUrl,
    aboutApiUrl,
    trackingsApiUrl,
} from './api';
export { baseUrlApi } from './api';

export const common: CommonConfig = {
    baseUrlApi,
    baseUserUrlApi,
    baseContentUrlApi,
    baseAnnotationUrlApi,
    baseExerciseUrlApi,
    baseEventsUrlApi,
    ...userApiUrl,
    ...dashboardApiUrl,
    ...coursesApiUrl,
    ...teachersApiUrl,
    ...globalSearchApiUrl,
    ...guidesApiUrl,
    ...userProfileApiUrl,
    ...viewerApiUrl,
    ...annotationApiUrl,
    ...bookmarkApiUrl,
    ...viewerSearchApiUrl,
    ...exerciseApiUrl,
    ...selfAssessmentApiUrl,
    ...publicApiUrl,
    ...eventsApiUrl,
    ...faqsApiUrl,
    ...aboutApiUrl,
    ...trackingsApiUrl,

    id: 'contents-viewer-core',
    name: "Contents Viewer Core",
    motto: "Contents Viewer",
    version: 2,
    build: 18,
    patch: 15,
    logo: 'core/assets/images/logo.png',
    logoAlt: 'core/assets/images/logo-alt.png',
    iconPrefix: 'contents-viewer-icon',
    hideFooter: true,

    authenticationType: 'Token-Session',

    defaultLanguage: 'it',
    availableLanguages: ['it', 'en'],

    minPwdLength: 5,
    maxPwdLength: 40,

    disableTextCopy: false, //TODO: da rivedere, di default puoi copiare e incollare...

    chatSocketUrl: server.chatServer || '/chat/socket.io',

    dashboardModule: {
        studyPathCoursesConfig: {
            showImage: false,
            showStudents: true,
        },
        inProgressCoursesConfig: {
            showImage: true,
            showProgress: true,
            lowerHeight: true,
        },
    },
    globalSearchModule: {
        contentsPreviewConfig: {
            showContentTypeIcon: true,
            showImage: true,
            lowerHeight: true,
            showStarIcon: true,
        },
    },
    teachersModule: {
        coursesPreviewConfig: {
            showContentTypeIcon: true,
            showImage: true,
            lowerHeight: true,
            showStarIcon: true,
        },
    },
    loginModule: {
        hideRegistration: false,
        hidePasswordForgotten: false,
        customMessagePosition: 'below-form',
    },

    registrationModule: {
        registrationType: 'multipleSteps',
    },

    myCoursesModule: {
        hideAdvancedSearch: false,
        coursesPreviewConfig: {
            showImage: true,
            showProgress: true,
        },
    },

    myGuidesModule: {
        hideAdvancedSearch: false,
    },

    viewerModule: {
        trackProgressType: 'auto',
        liquidViewer: {
            indexPath: 'core/assets/liquidViewerShell/index.html',
            customCssPath: '',
            config: {
                platform: 'web',
                alignedBottomAudioPlayer: false,
                autoPlayAudio: false,
                autoPlayVideo: false,
                h5pLibConfig: {
                    libFolder: 'assets/h5p-standalone', // path relative to liquidViewerShell libFolder
                },
            },
        },
        toolbar: {
            config: {
                position: 'left',
                floating: false,
            },
        },
    },
    analytics: {
        enable: false,
    },
    calendarModule: {
        hideSidebar: false,
        hideFooter: false,
        mobileBreakpoint: 700,
        customViewConfig: {
            customViews: (locale: typeof common.availableLanguages[number]) => ({
                listLabel: {
                    type: 'list',
                    duration: { months: 1 },
                    buttonText: locale === 'en' ? 'list' : 'Lista',
                },
                /* weekLabel: {
                    type: 'timeGrid',
                    duration: { days: 7 },
                    buttonText: locale === 'en' ? 'week' : 'Settimana',
                    titleFormat: { year: 'numeric', month: '2-digit', day: '2-digit' },
                }, */
            }),
            toolbarConfig: (isMobile) => ({
                primary: {
                    left: 'prev,next,today',
                    center: 'title',
                    right: isMobile ? undefined : 'dayGridMonth,timeGridWeek,listLabel',
                },
                secondary: {
                    left: 'prev,today',
                    center: 'title',
                    right: 'next',
                },
                basic: {
                    left: 'title',
                    center: '',
                    right: '',
                }
            }),
        },
        globalToolbarConfig: 'primary',
        viewerToolbarConfig: 'secondary',
        globalDesktopLabel: 'weekLabel',
        viewerDesktopLabel: 'listLabel',
        globalMobileLabel: 'listLabel',
        viewerMobileLabel: 'listLabel',
        resetViewOnResize: true,
        showFilterByMyCourses: false,
        coursesPreviewConfig: {
            showContentTypeIcon: true,
            showImage: true,
            lowerHeight: true,
            showStarIcon: true,
        },
        colorPalette: [
            "#FF9800", // Arancione
            "#2196F3", // Blu
            "#00BCD4", // Ciano
            "#4CAF50", // Verde
            "#F44336", // Rosso
            "#9C27B0", // Viola
            "#3F51B5", // Indaco
            "#673AB7", // Viola scuro
            "#03A9F4", // Azzurro
            "#009688", // Verde acqua
            "#8BC34A", // Verde chiaro
            "#CDDC39", // Verde lime
            "#FFEB3B", // Giallo
            "#FFC107", // Ambra
            "#FF5722", // Arancione scuro
            "#795548", // Marrone
            "#9E9E9E", // Grigio medio (Usare con cautela per testi piccoli)
            "#607D8B", // Blu grigio
            "#00796B", // Verde scuro
            "#AFB42B", // Verde oliva
            "#FFA000", // Arancione intenso
            "#D32F2F", // Rosso scuro
            "#512DA8", // Viola molto scuro
            "#1A237E", // Blu notte
            "#00ACC1", // Ciano brillante
            "#43A047", // Verde brillante
            "#EF6C00", // Arancione bruciato
            "#B71C1C", // Rosso cardinale
            "#4A148C", // Viola profondo
            "#0D47A1"  // Blu reale
        ],
    },
};
